import React, { useEffect, useState } from 'react';
import LikeIcon from '../../../../images/v2/responseList/ThumbsUp.svg';
import DislikeIcon from '../../../../images/v2/responseList/ThumbsDown.svg';
import CopyIcon from '../../../../images/v2/responseList/copy.svg';
import likedIcon from '../../../../images/v2/responseList/ThumbsUpFilled.svg';
import dislikedIcon from '../../../../images/v2/responseList/ThumbsDownFilled.svg';
import { useFeedbackHandler } from '../../../renderer/utils/FeedbackHandler';
import { EptFeedbackSourcesProps } from '../types';

interface FeedbackData {
  likes: number;
  dislikes: number;
  user_feedback: string | null;
}

const EptFeedbackSources: React.FC<EptFeedbackSourcesProps> = ({
  data,
  column,
  responseId,
}) => {
  const [feedbackData, setFeedbackData] = useState<FeedbackData>({
    likes: data.likes || 0,
    dislikes: data.dislikes || 0,
    user_feedback: data.user_feedback || null,
  });
  const { sendFeedback } = useFeedbackHandler();

  useEffect(() => {
    setFeedbackData({
      likes: data.likes || 0,
      dislikes: data.dislikes || 0,
      user_feedback: data.user_feedback || null,
    });
  }, [data, column]);

  const handleFeedback = async (feedback: boolean): Promise<void> => {
    try {
      // Implement toggle behavior
      let feedbackToSend: boolean | null;

      if (feedback === true && feedbackData.user_feedback === 'like') {
        // User clicked like but already liked - make neutral
        feedbackToSend = null;
      } else if (
        feedback === false &&
        feedbackData.user_feedback === 'dislike'
      ) {
        // User clicked dislike but already disliked - make neutral
        feedbackToSend = null;
      } else {
        // Normal feedback behavior
        feedbackToSend = feedback;
      }

      const result = await sendFeedback(
        responseId,
        feedbackToSend,
        data.url,
        false
      );
      console.log('Feedback API result:', result);

      // Update local state with the response
      if (result) {
        setFeedbackData({
          likes: result.likes || 0,
          dislikes: result.dislikes || 0,
          user_feedback: result.user_feedback || null,
        });
      }
    } catch (error) {
      console.error('Error sending feedback:', error);
    }
  };

  return (
    <div className="feedback-copy">
      <a
        href="/"
        className="chat-feedback"
        onClick={e => {
          e.preventDefault(); // Prevent default anchor link behavior
          handleFeedback(true); // Send feedback with the response ID
        }}
      >
        <img
          src={feedbackData.user_feedback === 'like' ? likedIcon : LikeIcon}
          alt="Like"
        />
        <span className="feedback-count">{feedbackData.likes}</span>
      </a>
      <a
        href="#"
        className="chat-feedback"
        onClick={e => {
          e.preventDefault(); // Prevent default anchor link behavior
          handleFeedback(false); // Send feedback with the response ID
        }}
      >
        <img
          src={
            feedbackData.user_feedback === 'dislike'
              ? dislikedIcon
              : DislikeIcon
          }
          alt="Dislike"
        />
        <span className="feedback-count">{feedbackData.dislikes}</span>
      </a>
    </div>
  );
};

export default EptFeedbackSources;
